import {
  AppBar,
  Toolbar,
  Button,
  Drawer,
  Grid,
  Box,
  Container,
  Link,
  makeStyles
} from "@material-ui/core";
import React, { useState, useEffect, useContext, useMemo } from "react";
import Logo from "./../../component/Logo";
import Scroll from "react-scroll";

const ScrollLink = Scroll.Link;

const useStyles = makeStyles((theme) => ({
  appBar: {
    background: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(10px)",
    borderBottom: "1px solid rgba(179, 218, 255, 0.2)",
    boxShadow: "0 2px 20px rgba(0, 0, 0, 0.05)",
  },
  toolbar: {
    minHeight: "70px",
    padding: "0 24px",
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    "& a": {
      textDecoration: "none",
    },
  },
}));

export default function TopBar() {
  const classes = useStyles();

  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });

  const { mobileView, drawerOpen } = state;

  useEffect(() => {
    const setResponsiveness = () => {
      setState((prevState) => ({
        ...prevState,
        mobileView: window.innerWidth < 1080,
      }));
    };

    setResponsiveness();
    window.addEventListener("resize", setResponsiveness);

    return () => {
      window.removeEventListener("resize", setResponsiveness);
    };
  }, []);



  const femmecubatorLogo = (
    <Box className={classes.logoContainer}>
      <Link href="/">
        <Logo className="logoImg" />
      </Link>
    </Box>
  );



  const displayMobile = () => {
    return (
      <Toolbar className={classes.toolbar}>
        <Box style={{ width: "100%", display: "flex", justifyContent: "center" }}>
          {femmecubatorLogo}
        </Box>
      </Toolbar>
    );
  };
  
  const displayDesktop = () => {
    return (
      <Container maxWidth="lg" style={{ backgroundColor: "#f4f4f4" }}>
        <Toolbar className={classes.toolbar}>
          {femmecubatorLogo}
          <Box style={{ flexGrow: 1 }} />
        </Toolbar>
      </Container>
    );
  };
  return (
    <>
      <AppBar
        elevation={0}
        className={classes.appBar}
      >
        <Box style={{ backgroundColor: "#f4f4f4" }}>{mobileView ? displayMobile() : displayDesktop()}</Box>
      </AppBar>
    </>
  );
}
